module.exports = __webpack_public_path__ + "img/cash-managment-1.083968d9.png";